import { computed, inject, signal, Signal } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiCollectionRepository,
  ReadonlyRepositoryCollectionService,
} from '@softline/core';
import { SOFTLINE_API_PMS_ROSTER_DEPARTMENT_HEADS } from '../roster.api';
import { DepartmentHead } from '../types/department-head';

export interface RosterDepartmentHeadQuery {
  cutoffdate?: string;
}

export class RosterDepartmentHeadService extends ReadonlyRepositoryCollectionService<
  DepartmentHead,
  DepartmentHead[],
  RosterDepartmentHeadQuery
> {
  readonly query = signal<undefined | Signal<RosterDepartmentHeadQuery>>(undefined);
  readonly today = signal<string>(new Date().toISOString().split('T')[0]);
  override params: Signal<any> = computed(() => {
    return {
      cutoffdate: this.query()?.()?.cutoffdate ?? this.today(),
    };
  });

  constructor() {
    super(inject(RosterDepartmentHeadRepository));
  }

  protected override getAll(
    result: DepartmentHead[] | null | undefined
  ): DepartmentHead[] {
    return result ?? [];
  }
}

export class RosterDepartmentHeadRepository extends ReadonlyHttpApiCollectionRepository<
  DepartmentHead[],
  RosterDepartmentHeadQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_PMS_ROSTER_DEPARTMENT_HEADS);
  }

  protected override getLoadQueryParams(
    params: RosterDepartmentHeadQuery
  ): Dictionary<unknown> | undefined {
    return { ...params };
  }
}

export const provideRosterDepartmentHeadService = () => [
  RosterDepartmentHeadService,
  RosterDepartmentHeadRepository,
];
